const EMAIL_ADDRESS_REGEX: RegExp =
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**
 * Whether a string is shaped like an email address.
 *
 * Lives in `shared/` because it is load-bearing for login in BOTH web apps: the engine sign-in
 * dispatch ("email-shaped goes to `signIn.email`, everything else to `signIn.username`") is a
 * pinned contract, and two copies of this regex would eventually disagree about which endpoint
 * an identifier belongs to — a user who can sign in on one app and not the other.
 */
export const getIsEmailAddress = (value: string): boolean => EMAIL_ADDRESS_REGEX.test(value);
